import { RISK_RULES } from "../../contracts/src/risk.ts";

export type FreshnessLevel = "live" | "delayed" | "offline";

export interface Freshness {
  level: FreshnessLevel;
  label: "Live" | "Delayed" | "Offline";
  detail: string;
}

export function getFreshness(lastUpdatedAt: number, nowSeconds: number): Freshness {
  const age = Math.max(0, nowSeconds - lastUpdatedAt);
  if (age <= RISK_RULES.delayedAfterSeconds) return { level: "live", label: "Live", detail: "資料同步正常" };
  if (age <= RISK_RULES.offlineAfterSeconds) return { level: "delayed", label: "Delayed", detail: "資料延遲超過 3 分鐘" };
  return { level: "offline", label: "Offline", detail: "資料超過 10 分鐘未更新" };
}
